'use client';

import { createContext, useContext } from 'react';

interface MenuSelectionContextValue {
  readonly isSelected: boolean;
}

const MenuSelectionContext = createContext<MenuSelectionContextValue | null>(
  null
);

MenuSelectionContext.displayName = 'MenuSelectionContext';

function useMenuSelectionContext(): MenuSelectionContextValue {
  const context = useContext(MenuSelectionContext);
  if (context === null) {
    throw new Error(
      'Menu.ItemIndicator must be used inside Menu.MultiSelectItem or Menu.SingleSelectItem.'
    );
  }
  return context;
}

export { MenuSelectionContext, useMenuSelectionContext };
